function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M86.3,389.2c0,6.8,5.5,12.3,12.3,12.3h103.7c3.9,8.6,12.5,14.5,22.5,14.5h62.5c10,0,18.6-6,22.4-14.5h103.8 c6.8,0,12.3-5.5,12.3-12.3s-5.5-12.3-12.3-12.3H299.6c-6.8,0-12.3,5.5-12.3,12.3l-0.1,2.3l-62.6-0.1v-2.2c0-6.8-5.5-12.3-12.3-12.3 H98.5C91.8,376.9,86.3,382.4,86.3,389.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M488.6,376.9h-23.2V153.9c0-6.8-5.5-12.3-12.3-12.3c-6.8,0-12.3,5.5-12.3,12.3v235.3c0,6.8,5.6,12.3,12.3,12.3h23.1v11 c0,12.5-10.2,22.7-22.7,22.7H58.3c-12.5,0-22.7-10.2-22.7-22.7v-11h23.1c6.8,0,12.3-5.5,12.3-12.3V153.9c0-6.8-5.5-12.3-12.3-12.3 s-12.3,5.5-12.3,12.3v223.1H23.4c-6.8,0-12.3,5.5-12.3,12.3v23.2c0,26,21.2,47.2,47.2,47.2h395.3c26,0,47.2-21.2,47.2-47.2v-23.2 C500.8,382.4,495.4,376.9,488.6,376.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M160,329.4c4.9,0,9.5-2.1,12.7-5.9l44.6-51.6H377c21.2,0,38.4-17.2,38.4-38.4V90.8c0-21.2-17.2-38.4-38.4-38.4H135.3 c-21.2,0-38.4,17.2-38.4,38.4v142.7c0,21.2,17.2,38.4,38.4,38.4h7.7v40.5C143,321.8,150.6,329.4,160,329.4z M135.3,247.4 c-7.7,0-13.9-6.2-13.9-13.9V90.8c0-7.7,6.2-13.9,13.9-13.9H377c7.7,0,13.9,6.2,13.9,13.9v142.7c0,7.7-6.2,13.9-13.9,13.9H211.7 c-3.6,0-6.9,1.5-9.3,4.2l-34.9,40.4v-32.4c0-6.8-5.5-12.3-12.3-12.3H135.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M229,202.3c2.4,2.4,5.5,3.6,8.7,3.6c3.1,0,6.2-1.2,8.6-3.6l63.4-63.1c4.8-4.8,4.8-12.5,0.1-17.3c-4.8-4.8-12.5-4.8-17.3,0 l-54.8,54.4l-17.9-18c-4.8-4.8-12.5-4.8-17.3,0c-4.8,4.8-4.8,12.5,0,17.3L229,202.3z"
}));

var SvgIconDistributeWorkload = function SvgIconDistributeWorkload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Artwork",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    width: 24,
    height: 25,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDistributeWorkload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_distribute-workload.6edd1b5a.svg";
export { ForwardRef as ReactComponent };